<template>
    <div class="home-wrap">
        <van-loading
            v-if="isLoading && !getIsToca()"
            type="spinner"
            size="26px"
            class="spinner"
            color="#1989fa"
        />
        <div class="home" v-show="!isLoading">
            <!-- pc -->
            <div class="pc-wrap" v-if="!isPhone">
                <div class="no-start" v-if="!isStart">
                    <img
                        src="https://m.elongstatic.com/year-wish/2025-title1.png"
                        alt=""
                        class="pc-title"
                    />
                    <div class="endTimeTitle">距离开始收集祝福倒计时</div>
                    <CountdownTime :endDate="startTime" />
                </div>
                <div class="started" v-else>
                    <img
                        src="https://m.elongstatic.com/year-wish/2025-title1.png"
                        alt=""
                        class="pc-title2"
                    />
                    <!-- <div class="page-top"> -->
                    <img
                        src="https://m.elongstatic.com/year-wish/tongcheng-logo.png"
                        alt=""
                        class="logo"
                    />
                    <!-- </div> -->
                    <div class="video-con" v-if="!isPhone">
                        <video
                            id="myVideo"
                            class="my-video"
                            ref="yearVideo"
                            autoplay
                            preload="auto"
                            :src="videoUrl"
                            :controls="showControls"
                            @click="playVideo2"
                        ></video>
                    </div>
                    <div class="btn-barrage" @click="openWish" v-if="detail">
                        <img
                            src="https://m.elongstatic.com/year-wish/wish-he.png"
                            alt=""
                        />
                    </div>
                    <div class="btn-barrage" @click="openWish" v-else>
                        <img
                            src="https://m.elongstatic.com/year-wish/wishTohe.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>

            <!-- h5 -->
            <div class="mobile-wrap" v-else>
                <div class="no-start" v-if="!isStart">
                    <img
                        class="tc-logo"
                        src="https://m.elongstatic.com/year-wish/2025-bg-title3x.png"
                        alt=""
                    />
                    <img
                        class="bg-title"
                        src="https://m.elongstatic.com/year-wish/2025-bg-kv23x.png"
                        alt=""
                    />
                    <div class="nianhui-txt">
                        <div>年度总结表彰大会&</div>
                        <div>关键战役发布会</div>
                    </div>
                    <div class="endTimeTitle">距离开始收集祝福倒计时</div>
                    <CountdownTime :endDate="startTime" />
                </div>
                <div
                    style="display: flex; flex-direction: column; align-items: center"
                    v-else
                >
                    <img
                        class="tc-logo"
                        src="https://m.elongstatic.com/year-wish/2025-bg-title3x.png"
                        alt=""
                    />
                    <img
                        class="bg-title"
                        src="https://m.elongstatic.com/year-wish/2025-bg-kv23x.png"
                        alt=""
                    />
                    <div class="video-con" v-if="true">
                        <video
                            id="myVideo"
                            class="my-video"
                            ref="yearVideo"
                            autoplay
                            webkit-playsinline="isiPhoneShowPlaysinline"
                            x5-playsinline="isiPhoneShowPlaysinline"
                            playsInline="isiPhoneShowPlaysinline"
                            x5-video-player-fullscreen="false"
                            x5-video-player-type="h5-page"
                            x-webkit-airplay="true"
                            preload="auto"
                            poster="../assets/poster2025-2.jpg"
                            @click="playVideo"
                            :src="videoUrl"
                        ></video>
                    </div>

                    <div class="mobile-btn get-btn" @click="openWish()"></div>
                    <!-- <div class="mobile-btn example-btn" @click="openWish()">查看别人的心愿</div> -->
                </div>
            </div>

            <van-overlay :show="showDialog" z-index="999">
                <div class="wrapper" @click.stop>
                    <div class="dialog">
                        <img
                            class="dialog-close"
                            src="https://m.elongstatic.com/year-wish/wish-close-icon.png"
                            @click="closeQrDialog"
                        />
                        <img
                            class="qr-bg"
                            src="https://m.elongstatic.com/year-wish/code-icon.png"
                        />

                        <div class="qr-img">
                            <img v-if="!loading" class="qrImgUrl" :src="qrImgUrl" />
                            <van-loading v-if="loading" class="loading" />
                        </div>

                        <div class="qr-desc">
                            扫描上方二维码，快来参加年会祝福活动吧～
                        </div>
                    </div>
                </div>
            </van-overlay>

            <!-- <van-overlay :show="showExample" z-index="999">
                <div class="wrapper" @click.stop>
                    <div class="overlay" >
                        <img class="dialog-close2" src="http://m.elongstatic.com/year-wish/close2.png"  @click="(showExample = false)"/>
                        <div class="example-box box1">
                            <img class="avatar" src="http://m.elongstatic.com/year-wish/wish-default.png"/>
                            <div class="example-right">
                                <div class="user-name">小袁同学</div>
                                <div class="example-text">
                                    <div class="example-triangle"></div>
                                    <div class="example-txt">去年我实现的心愿是送团队伙伴一本书，初衷是源于“知识的力量”，我想借书中的一 句话告诉他们“人生当中,总是有些太多的不 确定”，唯有持续学习，夯实基础，方能行的更远。 </div>
                                </div>
                            </div>
                        </div>
                        <div class="example-box">
                            <img class="avatar" src="http://m.elongstatic.com/year-wish/wish-default.png"/>
                            <div class="example-right">
                                <div class="user-name">小吕同学</div>
                                <div class="example-text">
                                    <div class="example-triangle"></div>
                                    <div class="example-txt">去年我实现的心愿是送给爸妈结婚30周年纪 念日一套婚纱照。当时就想着给他们准备一 个惊喜、留一份美好回忆。其实我想说：“ 我们都是这漫长岁月里的普通人，多去创造 一些闪闪发光的回忆吧。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-overlay> -->
        </div>
    </div>
</template>

<script>
import {
    applyfortoken,
    getTokenApi,
    getQrImg,
    wishDetail,
    getScheme,
    qryMVUrl,
    qryWishTime,
} from "../service/api";
import CryptoJS from "crypto-js";
import { Toast, Loading } from "vant";
import enableInlineVideo from "iphone-inline-video";
import CountdownTime from "./components/countdownTime.vue";
import { isTimeReached } from "../utils/utils";

export default {
    name: "HomeView",
    components: {
        CountdownTime,
    },
    data() {
        return {
            isLoading: true,
            videoUrl: "",
            showDialog: false,
            qrImgUrl: null,
            time: null,
            loading: false,
            showExample: false,
            detail: null,
            isAutoDialog: localStorage.getItem("isAutoDialog") || false,
            isPhone: false,
            isToca: false, // 是否是在同程管家中打开
            wishEndTime: null,
            isEnd: false,
            isStart: false,
            redirectUrl: process.env.VUE_APP_REDIRECT_URL,
            showControls: true,
            startTime: "",
        };
    },
    async created() {
        // const isToca = await this.getIsToca();
        this.getVideoUrl();
        this.showControls = !this.getIsToca();
    },
    async mounted() {
        // const vConsole = new window.VConsole();
        // console.log(vConsole);

        this.getVideoUrl();
        this.isPhoneFn();
        const str = location.search.slice(1);
        const arr = str.split("&");
        const param = {};
        arr.forEach((v) => {
            const array = v.split("=");
            if (array && array.length) param[array[0]] = array[1];
        });
        const { code, state } = param;

        if (code && state && !this.checkLogin()) {
            await this.getTokenApiFn(code, state);
        }
        // 获取心愿活动结束时间
        await this.qryWishEndTimeFn();
        if (!this.checkLogin()) {
            this.isLoading = true;
        } else {
            this.isLoading = false;
        }
        if (this.checkLogin()) {
            if (this.isEnd && !this.isPhone) {
                // 如果心愿活动填写时间已经结束   就直接跳转到心愿页面（弹幕页面）
                this.$router.push("/wish-wall");
                // this.openWish();
                return;
            }
            this.detail = await this.getWishDetail();
            // 如果不是移动端 且 用户已经填写过心愿  就直接跳转到心愿页面（弹幕页面）
            if (this.detail && !this.isPhone) {
                this.openWish();
                return;
            }
            console.log("执行了");
        } else {
            // 如果不是localhost 就自动登录
            if (location.href.indexOf("//localhost:") === -1) {
                this.applyfortokenFn();
            }
        }

        // 如果有登录信息 且 是刚刚从统一登录返回到此页面  那么就自动调用 this.openWish() 即跳转查看我的心愿页面（弹幕页面）
        // 不用让用户重复点击 查看我的心愿按钮
        if (!this.isAutoDialog && this.checkLogin() && !this.isPhone) {
            this.isAutoDialog = true;
            localStorage.setItem("isAutoDialog", true);
            // this.openWish();
            return;
        }
        // window.localStorage.setItem('access_token','707927b9ab347bcd9066261e284ae717')
    },
    methods: {
        // 判断是否是在同程管家里面发开的此页面
        getIsToca() {
            console.log(window.navigator.userAgent);
            if (window.navigator.userAgent.indexOf("toca") > -1) {
                return true;
            }
            return false;
        },
        // 获取心愿的开始时间，结束时间，年会的开始时间
        qryWishEndTimeFn() {
            return new Promise((resolve) => {
                qryWishTime()
                    .then((res) => {
                        if (res.code === "0") {
                            const { beginTime, endTime } = res.data;
                            this.isEnd = isTimeReached(endTime);
                            // this.isStart = false
                            this.isStart = isTimeReached(beginTime);
                            this.startTime = beginTime;
                            // this.startTime = "2024-12-24 00:00:00"
                            console.log("this.isStart", this.startTime);
                            resolve(true);
                        }
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        // 获取视频链接
        getVideoUrl() {
            qryMVUrl().then((res) => {
                if (res.code === "0") {
                    this.videoUrl = res.data;
                }
            });
        },
        isPhoneFn() {
            var os = (function () {
                var ua = navigator.userAgent,
                    isWindowsPhone = /(?:Windows Phone)/.test(ua),
                    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
                    isAndroid = /(?:Android)/.test(ua),
                    isFireFox = /(?:Firefox)/.test(ua),
                    isChrome = /(?:Chrome|CriOS)/.test(ua),
                    isTablet =
                        /(?:iPad|PlayBook)/.test(ua) ||
                        (isAndroid && !/(?:Mobile)/.test(ua)) ||
                        (isFireFox && /(?:Tablet)/.test(ua)),
                    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
                    isPc = !isPhone && !isAndroid && !isSymbian;
                return {
                    isTablet: isTablet,
                    isPhone: isPhone,
                    isAndroid: isAndroid,
                    isPc: isPc,
                };
            })();
            if (os.isAndroid || os.isPhone) {
                // 手机
                this.isPhone = true;
                return true;
            } else if (os.isTablet) {
                // 平板
                this.isPhone = false;
                return false;
            } else if (os.isPc) {
                // 电脑
                this.isPhone = false;
                return false;
            }
        },
        playVideo() {
            const video = this.$refs.yearVideo;
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        },
        playVideo2() {
            if (!this.showControls) {
                const video = this.$refs.yearVideo;
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            }
        },
        // 检查是否登录
        checkLogin() {
            return localStorage.getItem("access_token");
        },
        // 获取统一登录链接
        applyfortokenFn() {
            applyfortoken(this.redirectUrl).then((res) => {
                if (res.code === "0") {
                    location.href = res.data;
                } else {
                    Toast.fail(res.msg);
                }
            });
        },
        // 获取token
        getTokenApiFn(code, state) {
            return new Promise((resolve) => {
                console.log(code, state);
                const param = {
                    code,
                    state,
                };
                getTokenApi(param).then((res) => {
                    console.log(res);
                    if (res.code === "0") {
                        // 如果没有获取到token说明 url上的code和state已经获取过token了 不能再次通过那code、state获取token
                        // 那么就 清除缓存 跳转到首页
                        if (!res.data) {
                            localStorage.removeItem("access_token");
                            localStorage.removeItem("isAutoDialog");
                            this.$router.replace("/blank");
                            return;
                        }
                        // 设置token
                        localStorage.setItem("access_token", res.data);
                    } else {
                        Toast.fail(res.msg);
                    }
                    resolve();
                });
            });
        },
        // 点击传递你的心愿
        openWish() {
            // 如果授权登陆过了
            if (this.checkLogin()) {
                // 如果是移动端 就获取url scheme 跳转到小程序
                if (this.isPhone) {
                    this.jump();
                } else {
                    // 非移动端  如果自己已经填过心愿 就跳转弹幕页面，否则就弹出太阳码弹窗
                    if (this.detail) {
                        this.$router.push("/wish-wall");
                    } else {
                        this.showDialog = true;
                        this.getQrImgFn();
                    }
                }
            } else {
                this.applyfortokenFn();
            }
        },
        // 获取太阳码
        getQrImgFn() {
            const bizid =
                "wish-" +
                CryptoJS.MD5(this.checkLogin()).toString().toUpperCase().substring(0, 16);
            const param = {
                appId: "wx0bb689f8ccb553db",
                bizId: bizid,
                refresh: false,
                client: "C",
                path: "pages/community/blankPageShare/blankPageShare",
                scene: "b=" + bizid,
                extend: `type=${
                    this.isEnd ? "wish-wall" : "wish"
                }&access_token=${this.checkLogin()}&fromToca=${this.getIsToca()}&shopId=1000000000724`,
                width: 280,
                backColor: "WHITE",
                smallProgramPath: "/pages/community/blankPageShare/blankPageShare",
                business: "600000",
                templateId: 589,
            };
            this.loading = true;
            console.log(param);
            getQrImg(param)
                .then((res) => {
                    console.log(res);
                    if (res.code === "0") {
                        this.qrImgUrl = res.data;
                        // 轮询本人心愿详情
                        this.loopGetDetail();
                    } else {
                        Toast.fail(res.msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 轮询本人心愿详情
        loopGetDetail() {
            this.time = setInterval(async () => {
                const res = await this.getWishDetail();
                if (res) {
                    clearInterval(this.time);
                    this.$router.push("/wish-wall");
                }
            }, 1000);
        },
        // 获取本人心愿详情
        getWishDetail() {
            return new Promise((resolve) => {
                wishDetail({}).then((res) => {
                    if (res.code === "0" && res.data) {
                        // 如果查询到本人的心愿详情数据，就停止轮询，跳转到弹幕墙页面
                        resolve(res.data);
                    } else {
                        resolve();
                    }
                });
            });
        },
        // 关闭太阳码弹窗
        closeQrDialog() {
            this.showDialog = false;
            clearInterval(this.time);
        },
        jump() {
            if (!this.checkLogin()) {
                return;
            }
            const param = {
                path: this.isEnd
                    ? "pages/year-wish/wish-wall/index"
                    : "pages/year-wish/wish-homepage/index",
                query: `access_token=${this.checkLogin()}&fromTCGJ=${this.getIsToca()}`,
                business: "600000",
                templateId: 589,
            };
            getScheme(param).then((res) => {
                if (res.code === "0" && res.data) {
                    console.log("--------获取scheme");
                    console.log(res);
                    // 如果查询到本人的心愿详情数据，就停止轮询，跳转到弹幕墙页面
                    location.href = res.data;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.home {
    width: 100%;
    height: 100%;
    background: url("https://m.elongstatic.com/year-wish/2025new-year2.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden;
}
.pc-title {
    width: 1229px;
    display: block;
    margin: 0 auto;
    // margin-top: 318px;
}
.pc-title2 {
    width: 30%;
    margin: 0 auto;
    margin-bottom: 33px;
    position: absolute;
    top: 65px;
}

.home > img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.pc-wrap {
    display: block;
    height: 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
}
.started {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
}
// .mobile-wrap {
//     display: none;
// }

.video-con {
    // position: absolute;
    left: 0;
    right: 0;
    top: 25%;
    margin: auto;
    text-align: center;
    border-radius: 10px;
    overflow: hidden;
    width: 856px;
    height: 503.0465px;
    // width: 730px;
    // height: 429px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("https://m.elongstatic.com/year-wish/video-BG.png");
    background-size: 100% 100%;
}

.dg-code {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    opacity: 0.5;
    background: #000;
}

.btn-barrage {
    animation: luckyBageShake 1s infinite;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 5%;
    cursor: pointer;
    display: flex;
    justify-content: center;
}

.btn-barrage > img {
    width: 24%;
    height: 5%;
}

.logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 405px;
}

// .page-top {
//     width: 100%;
//     display: flex;
//     justify-content: center;
// }

.wish-title {
    width: 70%;
    margin-top: 2%;
}

.my-video {
    width: 93%;
    // height: 100%;
    // background-color: #000;
    // border-radius: 10px;
}

.example {
    width: 27%;
    position: absolute;
    bottom: 3%;
    left: 1%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.example > img {
    width: 100%;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .dialog {
        width: 600px;
        height: 500px;
        background-color: white;
        position: relative;
        // border-radius: 4px;
        border-radius: 60px;
        .qr-bg {
            width: 160px;
            height: 182px;
            left: 50%;
            top: -85px;
            position: absolute;
            transform: translate(-50%, 0);
        }
        .dialog-close {
            position: absolute;
            width: 80px;
            height: 80px;
            left: 50%;
            transform: translate(-50%, 0);
            bottom: -102px;
        }
        .qr-img {
            width: 300px;
            height: 300px;
            margin: 0 auto;
            margin-top: 110px;
            text-align: center;
            overflow: hidden;
            // border: 1px solid #dcdcdc;
            border-radius: 8px;
        }
        .loading {
            margin-top: 100px;
        }
        .qr-desc {
            font-weight: 600;
            text-align: center;
            margin-top: 28px;
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-500;
            text-align: CENTER;
            color: #333333;
            line-height: 14px;
        }
        .qrImgUrl {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 999;
            background: white;
        }
    }
    .overlay {
        width: 640px;
        box-sizing: border-box;
        // max-height: 736px;
        // min-height: 480px;
        // height: 542px;
        background-color: white;
        position: relative;
        border-radius: 16px;
        padding-bottom: 60px;
        // padding: 0 32px;
        // padding-top: 48px;
        // padding-bottom: 16px;
        // box-sizing: border-box;

        .dialog-close2 {
            position: absolute;
            width: 30px;
            height: 30px;
            top: 32px;
            right: 32px;
        }
        .example-box {
            width: 527px;
            // height: 193px;
            background: rgb(243, 243, 243, 0.8);
            border-radius: 10px;
            // opacity: 0.8;
            padding: 10px 16px 16px 10px;
            box-sizing: border-box;
            margin: 0 auto;

            display: flex;
            align-items: flex-start;
        }
        .box1 {
            margin-top: 80px;
        }
        .avatar {
            width: 60px;
            height: 60px;
            border: 1px solid #e1e1e1;
            border-radius: 5px;
        }
        .example-right {
            margin-left: 14.86px;
        }
        .user-name {
            font-size: 22px;
            font-family: PingFang SC, PingFang SC-Regular;
            color: #666666;
            line-height: 22px;
        }
        .example-text {
            width: 420px;
            // width: 86.8263%;
            // height: 134px;
            background: white;
            border: 1.27px solid #ececec;
            padding: 13px;
            border-radius: 8px;
            box-sizing: border-box;
            margin-top: 10px;
            position: relative;

            .example-triangle {
                display: block;
                position: absolute;
                left: -10px;
                top: 24px;

                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-right: 14px solid white;
                border-bottom: 10px solid transparent;
            }

            .example-txt {
                width: 100%;
                // height: 107px;
                font-size: 24px;
                line-height: 36px;
                color: #333;

                // overflow: hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-box-orient: vertical;
                // -webkit-line-clamp: 3;
            }
        }
    }
}

@keyframes luckyBageShake {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}

.bg-title {
    // width: 684px;
    width: 86.6%;
    // height: 105.29px;
    // width: 91.2346%;
    // height: 7.7155%;
    display: block;
    margin: 0 auto;
    margin-top: 30px;
}
.tc-logo {
    width: 53.3% !important;
    margin-top: 134px;
}
.mobile-time {
    // width: 83.3333%;
    overflow: hidden;
    width: 405px;
    height: 50px;
    line-height: 53.5px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 25px;
    background: rgba(255, 255, 255, 0.4);
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #fff;
    margin: 0 auto;
    margin-top: 30px;
    font-weight: 600;
}

.mobile-btn {
    background: url("https://m.elongstatic.com/year-wish/wish-he.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 666px;
    height: 120px;
    // line-height: 85px;
    // text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
    color: #fff8ed;
    font-size: 36px;
    font-weight: bold;
}
.example-btn {
    background: rgba(255, 255, 255, 0.4) !important;
    margin-top: 40px !important;
    color: #fff !important;
}

//当屏幕最小宽度为992px
@media screen and (max-width: 500px) {
    .home {
        background: url("https://m.elongstatic.com/year-wish/2025-bg3-2.jpg");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 100vh;
    }
    // .pc-wrap {
    //     display: none;
    // }
    .mobile-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }
    .video-con {
        width: 93.6%;
        height: 429px;
        // height: 388px;
        position: static;
        margin: 0 auto;
        margin-top: 20px;
        text-align: center;
    }
    .my-video {
        // width: 690px;
        // height: 338px;
        border-radius: 10px;
        width: 94.3%;
        height: 90.218%;
    }
    .no-start {
        .tc-logo {
            margin-top: 0px !important;
            margin-bottom: 25px;
        }
        .nianhui-txt {
            margin-top: 55px;
            div {
                width: 100%;
                font-size: 48px;
                font-family: PingFang TC, PingFang TC-300;
                font-weight: 400;
                text-align: CENTER;
                color: #ffffff;
                line-height: 56px;
                text-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.25);
            }
        }
        .endTimeTitle {
            margin-top: 170px;
            font-size: 30px;
            font-family: PingFang TC, PingFang TC-300;
            font-weight: 400;
            text-align: CENTER;
            color: #ffffff;
            line-height: 34px;
            text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        }
    }
}
// //当屏幕宽度 最小为768px 最大为991px时
// @media screen and (min-width:768px) and (max-width:991px) {
//     body {

//     }
// }
.home-wrap {
    position: relative;
    width: 100%;
    height: 100%;
}
.spinner {
    width: 100px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}
.endTimeTitle {
    margin-top: 47px;
    font-size: 40px;
    font-family: PingFang TC, PingFang TC-300;
    font-weight: 300;
    text-align: CENTER;
    color: #ffffff;
    line-height: 47px;
    text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
}
.no-start {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}
</style>
